import { render, staticRenderFns } from "./AvIcon.vue?vue&type=template&id=4bf4495f"
import script from "./AvIcon.vue?vue&type=script&lang=ts"
export * from "./AvIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports